var inIFrame = function() {
    try {
        //if these don't match then it's an iframe
        return window.self !== window.top;
    } catch (e) {
        //if an exception occurs then it's cross domain, hence iframe
        return true;
    }
};

var messagedialog = function(title, message) {    
	$.showMessageDialog({
		dialogID : '#errorMsgDialog',
		title : title,
		message : message
	});
};

    
